var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloudFileSelect(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 96,
    viewBox: "0 0 100 96",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "vaqvom6sxa",
    width: "364.6%",
    height: "364.6%",
    x: "-132.3%",
    y: "-132.3%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 15
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowBlurOuter1",
    result: "shadowMatrixOuter1",
    values: "0 0 0 0 0.263985711 0 0 0 0 0.787873641 0 0 0 0 0.780145836 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    filter: "url(#vaqvom6sxa)",
    transform: "translate(26 22)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0L48 0 48 48 0 48z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#43C9C7",
    fillRule: "nonzero",
    d: "M24 25.172l8.486 8.484-2.83 2.83L26 32.83V44h-4V32.826l-3.656 3.66-2.83-2.83L24 25.172zM24 4c7.108 0 13.089 5.327 13.908 12.388 5.136 1.4 8.532 6.278 8.063 11.58-.468 5.304-4.667 9.51-9.969 9.988v-4.028c2.505-.358 4.622-2.04 5.537-4.399s.485-5.028-1.124-6.981c-1.609-1.953-4.146-2.886-6.637-2.44.857-3.99-.797-8.102-4.18-10.386-3.381-2.285-7.813-2.285-11.195 0-3.382 2.284-5.036 6.395-4.179 10.386-3.8-.714-7.458 1.788-8.172 5.588-.714 3.8 1.788 7.458 5.588 8.172l.36.06v4.028c-5.302-.477-9.502-4.683-9.97-9.986-.47-5.303 2.926-10.181 8.062-11.582C10.911 9.327 16.892 3.999 24 4z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudFileSelect);
export default __webpack_public_path__ + "static/media/cloud_file_select.159e3702540fbdcb17d20cbc6748c73e.svg";
export { ForwardRef as ReactComponent };